export function handleVC2MessageReceived(data) {
    let newData;
    if (data && data.indexOf('|') > 0 && data.indexOf('{') === data.indexOf('|') + 1) {
        newData = JSON.parse(data.substring(data.indexOf('{'), data.length));
    }

    return newData;
}

export function parseFetchResponseJSON(response) {
    return response.json();
}

export function checkFetchResponseStatus(response) {
    let contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        } else if (response.status >= 400 && response.status < 500) {
            if (response.status === 404) {
                throw new Error('Network Error');
            } else {
                return response.json().then(err => {
                    throw new Error(err.description);
                });
            }
        } else { // this is a 500 error
            throw new Error('Internal Server Error');
        }
    }
}


// WEBPACK FOOTER //
// ./src/communications/commsHelpers.js